import {
  AddOutlined,
  DeleteOutline,
  EditOutlined,
  RefreshOutlined,
  RemoveRedEyeOutlined,
} from "@material-ui/icons";
import {
  Avatar,
  Box,
  Button,
  CardHeader,
  Grid,
  IconButton,
  LinearProgress,
} from "@mui/material";
import { useEffect, useState } from "react";
import AppButton from "../shares/AppButton";
import { DataGrid } from "@mui/x-data-grid";
import { getBackendProfilePictureLink } from "../../../Helpers/utilsHelper";
import { AssociationService } from "../../../service/AssociationService";
import useToast from "../../../hooks/useToast";
import { TYPE_NOTIFICATION } from "../shares/NotificationBull";
import useConfirmation from "../../../hooks/useConfirmation";
import MembreForm from "./MembreForm";
import { frFR } from "@mui/x-data-grid/locales";
import { useNavigate } from "react-router-dom";

const ListeMembreAssociation = ({ currentAssociation }) => {
  const [membres, setMembres] = useState([]);
  const [currentIdMembre, setCurrentIdMembre] = useState(null);
  const { Toast, showToast } = useToast();
  const [membreFormOpen, setMembreFormOpen] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const navigate = useNavigate();

  const { DialogComponent, openConfirmDialog } = useConfirmation();
  const handleFetchMembres = (currentAssociation) => {
    setDataLoading(true);
    AssociationService.showMembres(currentAssociation.uuid)
      .then((res) => {
        if (res && res.data) {
          setMembres(res.data);
        }
      })
      .finally(() => {
        setDataLoading(false);
      });
  };

  const confirmDeleteMembre = (membre) => {
    AssociationService.deleteMembre(
      membre.id_ext_responsable_association,
      currentAssociation.uuid
    ).then((res) => {
      if (res && res.success) {
        showToast(TYPE_NOTIFICATION.SUCCESS, res.message);
        handleFetchMembres(currentAssociation);
      } else {
        showToast(TYPE_NOTIFICATION.ERROR, res.message);
      }
    });
  };

  const handleDeleteMembre = (membre) => {
    openConfirmDialog(
      "Confirmation",
      "Voullez vous supprimer cette ligne?",
      () => confirmDeleteMembre(membre)
    );
  };
  const handleShowMembreDetail = (membre) => {
    navigate(`association-membre?ref=${membre.id_ext_responsable_association}`);
  };

  const table_colonne = [
    {
      field: "membre_pdp",
      headerName: "",
      minWidth: 50,
      flex: 0.25,
      renderCell: (params) => {
        return (
          <Grid>
            <Avatar
              sx={{
                m: 1,
                width: "clamp(20px, 15vw, 40px)",
                height: "clamp(20px, 15vw, 40px)",
                fontSize: "clamp(10px, 8vw, 18px)",
              }}
              alt={String(params.row.membre_nom).toUpperCase() || "Asso"}
              src={getBackendProfilePictureLink(params.row.photo)}
            />
          </Grid>
        );
      },
    },
    {
      field: "membre_nom",
      headerName: "Nom",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "membre_prenoms",
      headerName: "Prenoms",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "role_responsable",
      headerName: "Fonction",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "telephone1",
      headerName: "Telephone ",
      flex: 1,
      minWidth: 120,
    },
    {
      field: "action",
      headerName: "Actions",
      flex: 1,
      minWidth: 120,
      renderCell: (params) => {
        return (
          <Grid>
            <IconButton
              title="Afficher details membre"
              color="primary"
              onClick={(e) => handleShowMembreDetail(params.row)}
            >
              <RemoveRedEyeOutlined />
            </IconButton>
            <IconButton
              title="Modifier membre"
              color="primary"
              onClick={(e) =>
                handleEditMembre(params.row.id_ext_responsable_association)
              }
            >
              <EditOutlined />
            </IconButton>
            <IconButton
              title="Supprimer membre"
              color="warning"
              onClick={(e) => handleDeleteMembre(params.row)}
            >
              <DeleteOutline />
            </IconButton>
          </Grid>
        );
      },
    },
  ];

  useEffect(() => {
    // if (currentAssociation.uuid) {
    handleFetchMembres(currentAssociation);
    // }
  }, [currentAssociation]);

  const handleOpenMembreForm = (membreId) => {
    setMembreFormOpen(true);
    setCurrentIdMembre(membreId);
  };

  const handleAddMembre = () => {
    handleOpenMembreForm(null);
  };
  const handleEditMembre = (membreId) => {
    handleOpenMembreForm(membreId);
  };

  const handleCloseMembreForm = () => {
    setMembreFormOpen(false);
    handleFetchMembres(currentAssociation);
  };
  return (
    <>
      <MembreForm
        idMembre={currentIdMembre}
        open={membreFormOpen}
        onFormClose={handleCloseMembreForm}
        association_uuid={currentAssociation.uuid}
      />
      <DialogComponent />
      <Toast />
      <CardHeader
        title="Liste des membres et equipes permanents (Socio Organisateurs) "
        titleTypographyProps={{ variant: "h5" }}
        avatar={
          <Grid>
            <IconButton onClick={(e) => handleFetchMembres(currentAssociation)}>
              <RefreshOutlined />
            </IconButton>
          </Grid>
        }
        action={
          <Grid>
            <AppButton
              text="Ajouter"
              onClick={handleAddMembre}
              variant="contained"
              icon={<AddOutlined />}
            />
          </Grid>
        }
      />
      <Grid sx={{ overflowX: "auto", width: "100" }}>
        <Box display={dataLoading ? "" : "none"} sx={{ width: "100%" }}>
          <LinearProgress />
        </Box>
        <DataGrid
          sx={{
            width: {
              xs: "85.5vw",
              sm: "90vw",
              md: "93.5vw",
              lg: "100%",
            },
          }}
          autoHeight
          getRowId={(row) => row.id_ext_responsable_association}
          localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
          columns={table_colonne}
          rows={membres}
        />
      </Grid>
    </>
  );
};

export default ListeMembreAssociation;
